import { XIcon } from 'lucide-react';
import React, { useState } from "react";
import { FeedbackButton } from "@/feedback/FeedbackButton";

export const FeedbackFooter = () => {

  const [hidden, setHidden] = useState(false);

  if (hidden) return;

  return (
    <div className="text-xs p-3 flex items-center gap-2 justify-between border-t-[1px] bg-white shadow-inner">
      Help us improve by sharing your thoughts
      <div className="flex gap-2 items-center">
        <FeedbackButton className="text-xs" feature="Bottom footer"/>
        <button className="p-1 bg-gray-100 hover:bg-gray-200 rounded-md text-gray-500 z-10" onClick={() => setHidden(true)}>
          <XIcon size={16}/>
        </button>
      </div>
    </div>
  );
};
